<template>
  <div class="space-y-8">
    <section class="bg-white rounded-3xl border border-slate-200 overflow-hidden shadow-xl shadow-slate-200/50">
      <!-- HEADER -->
      <div class="px-8 py-5 flex flex-wrap items-center justify-between gap-6" style="background-color: #333333;">
          <div class="flex items-center gap-4">
            <div class="p-2 bg-orange-500/10 rounded-lg">
              <v-icon color="orange" small>mdi-format-list-bulleted-type</v-icon>
            </div>
            <h2 class="text-white font-black uppercase tracking-[0.2em] text-[11px]">Itens e Propostas</h2>
          </div>
          
          <div class="flex items-center gap-6 flex-1 justify-end max-w-3xl">
            <v-text-field
              v-model="search"
              placeholder="FILTRAR POR DESCRIÇÃO OU FORNECEDOR..."
              solo flat dense hide-details
              class="custom-field-dark bg-white/10 rounded-2xl w-full max-w-md"
              prepend-inner-icon="mdi-magnify"
            />
            <button 
              @click="$router.push(`/biddings-items/create/${bidding_id}`)"
              class="bg-orange-500 hover:bg-orange-600 text-white font-black text-[10px] px-8 h-12 rounded-xl shadow-xl transition-all flex items-center gap-3 uppercase tracking-widest group active:scale-95"
            >
              <v-icon color="white" size="18" class="group-hover:rotate-90 transition-transform">mdi-plus</v-icon>
              <span>Novo Item / Lote</span>
            </button>
          </div>
      </div>

      <div class="p-0">
          <v-data-table
            :headers="headers"
            :items="data"
            :search="search"
            :items-per-page="10"
            :loading="loader"
            loading-text="Sincronizando itens da licitação..."
            class="premium-table"
            hide-default-footer
          >
            <template v-slot:item.item_number="{ item }">
              <span class="text-[10px] font-black text-slate-400 font-mono tracking-widest bg-slate-50 px-2 py-1 rounded">#{{ item.item_number }}</span>
            </template>

            <template v-slot:item.item_description_desc="{ item }">
              <div class="flex flex-col py-3">
                <span class="text-xs font-black text-slate-700 uppercase tracking-tight">{{ item.item_description_desc }}</span>
                <span class="text-[9px] font-bold text-slate-400 uppercase tracking-widest mt-0.5">{{ item.provider_name || 'PARTICIPANTE NÃO DEFINIDO' }}</span>
              </div>
            </template>

            <template v-slot:item.item_price="{ item }">
              <span class="font-black text-slate-400 text-xs">R$ {{ item.item_price ? realMaskII(Number(item.item_price).toFixed(3)) : '0,000' }}</span>
            </template>

            <template v-slot:item.item_billing_price="{ item }">
              <span class="font-black text-slate-800 text-xs">R$ {{ item.item_billing_price ? realMaskII(Number(item.item_billing_price).toFixed(3)) : '0,000' }}</span>
            </template>

            <template v-slot:item.item_amount="{ item }">
              <span class="px-3 py-1 rounded-lg bg-slate-50 border border-slate-100 text-[10px] font-black text-slate-500 font-mono">
                {{ item.item_amount ? realMask(Number(item.item_amount).toFixed(2)) : '0,00' }}
              </span>
            </template>

            <template v-slot:item.item_status="{ item }">
              <div class="flex items-center gap-2">
                <div :class="['w-1.5 h-1.5 rounded-full', item.item_status ? 'bg-emerald-500 animate-pulse' : 'bg-rose-500']"></div>
                <span :class="['text-[9px] font-black uppercase tracking-widest', item.item_status ? 'text-emerald-600' : 'text-rose-600']">
                  {{ item.item_status ? "Ativo" : "Inativo" }}
                </span>
              </div>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <div class="flex justify-end gap-2 px-4">
                <v-btn 
                  icon small 
                  class="hover:bg-orange-50 group" 
                  @click="$router.push(`/biddings-items/edit/${item.item_id}/${bidding_id}`)"
                  title="Editar"
                >
                  <v-icon size="18" color="orange" class="group-hover:scale-110 transition-transform">mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn 
                  icon small 
                  class="hover:bg-red-50 group" 
                  @click="deleteItem(item.item_id)"
                  title="Excluir"
                >
                  <v-icon size="18" color="red" class="group-hover:scale-110 transition-transform">mdi-trash-can-outline</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:no-data>
              <div class="py-20 flex flex-col items-center justify-center text-slate-300">
                <div class="p-6 bg-slate-50 rounded-full mb-4">
                  <v-icon size="64" color="slate-100">mdi-playlist-remove</v-icon>
                </div>
                <p class="text-xs font-black uppercase tracking-[0.2em]">Nenhum item cadastrado</p>
              </div>
            </template>
          </v-data-table>
      </div>
    </section>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snack.show"
      :color="snack.color"
      timeout="4000"
      top
      elevation="24"
      class="custom-snack"
    >
      <div class="flex items-center gap-3">
        <v-icon color="white" small>{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
        <span class="text-xs font-black uppercase tracking-widest">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snack.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  props: ["bidding_id"],
  mixins: [Helpers],
  data: () => ({
    search: "",
    loader: true,
    data: [],
    snack: { show: false, message: "", color: "" },
    headers: [
      { text: "Item Nº", value: "item_number", align: "start", sortable: true },
      { text: "Descrição / Fornecedor Vencedor", value: "item_description_desc" },
      { text: "Prc Estimado", value: "item_price", align: "start" },
      { text: "Prc Licitado", value: "item_billing_price", align: "start" },
      { text: "Quantidade", value: "item_amount", align: "start" },
      { text: "Situação", value: "item_status", align: "center" },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/biddings/items/${this.bidding_id}`)
        .then((r) => {
          this.data = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.$store.dispatch("setLoader", false);
        });
    },
    deleteItem(id) {
      if (confirm("Deseja excluir este item da licitação?")) {
        this.$store.dispatch("setLoader", true);
        this.$http.delete(`/biddings/items/${id}`)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.success || r.data.error;
            this.snack.color = r.data.success ? "success" : "error";
            this.initialize();
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.premium-table ::v-deep table { 
  background-color: transparent !important; 
  border-collapse: separate; 
  border-spacing: 0; 
}

.premium-table ::v-deep th { 
  color: #94a3b8 !important; 
  font-weight: 900 !important; 
  text-transform: uppercase !important; 
  font-size: 10px !important; 
  letter-spacing: 0.15em !important;
  background-color: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0 !important;
  height: 64px !important;
  padding: 0 32px !important;
}

.premium-table ::v-deep td { 
  border-bottom: 1px solid #f8fafc !important;
  color: #334155 !important;
  padding: 12px 32px !important;
}

.premium-table ::v-deep tr:hover {
  background-color: #fcfcfc !important;
}

.custom-field-dark >>> .v-input__control .v-input__slot {
  background: transparent !important;
  font-size: 11px !important;
  font-weight: 900 !important;
  color: #ffffff !important;
  padding: 0 16px !important;
}

.custom-field-dark >>> input {
  color: #ffffff !important;
  text-transform: uppercase;
}

.custom-snack >>> .v-snack__wrapper {
  border-radius: 1.25rem !important;
}
</style>